import { render, staticRenderFns } from "./ys-footer.vue?vue&type=template&id=11b1b277&scoped=true"
import script from "./ys-footer.vue?vue&type=script&lang=js"
export * from "./ys-footer.vue?vue&type=script&lang=js"
import style0 from "./ys-footer.vue?vue&type=style&index=0&id=11b1b277&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1b277",
  null
  
)

export default component.exports